import React, { ReactNode } from 'react';
import groupBy from 'lodash.groupby';
import toPairs from 'lodash.topairs';
import { SelectOption } from '../types';
import BaseSelect from '../BaseSelect';

export const generateOptionsAndOptionGroups = (
  options: SelectOption[],
  minGroupsToDisplayHeader: number | undefined = 2,
) => {
  const groupedOptions = groupBy(
    options,
    (option: SelectOption) => option.group,
  );
  const shouldShowGroups =
    Object.keys(groupedOptions).length >= minGroupsToDisplayHeader;
  const renderOptions = (optionsList: SelectOption[]) =>
    optionsList.map((option) => (
      <BaseSelect.Content.ListBox.Option
        key={option.value}
        {...option}
        value={option.value}
        disabled={option.disabled}
      >
        {option.label}
      </BaseSelect.Content.ListBox.Option>
    ));
  return shouldShowGroups
    ? toPairs(groupedOptions).map<ReactNode>(([groupName, groupOptions]) => (
        <BaseSelect.Content.ListBox.OptionGroup
          key={groupName}
          name={groupName}
        >
          {renderOptions(groupOptions)}
        </BaseSelect.Content.ListBox.OptionGroup>
      ))
    : renderOptions(options);
};
